<template>
  <div class="home h-100">
    <template class="intro">
      <p class="text-light">
        Welcome! Please use the public tracker to request features or report
        bugs.
        <b-link href="https://github.com/Mxrk/tracker-poe/issues"
          >Tracker</b-link
        >. You can also join the
        <b-link href="https://discord.gg/fpnmfz3">Discord</b-link> if you have
        any questions or want to chat with others about your projects. Please
        check <b-link to="/features"> features</b-link>, if you are interested
        in a short introduction about the features of this site. This product
        isn't affiliated with or endorsed by Grinding Gear Games in any way.
      </p>
    </template>
    <h3 class="text-light">Hot Items</h3>
    <Table
      :fields="fields"
      :league="this.$parent.league"
      category="hot"
      :options="options"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/One-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Home",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      privateLeague: false,
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "change",
          thClass: "text-right",
          sortable: true,
          tdClass: "text-nowrap, text-right",
        },
        {
          key: "changeByPrice",
          thClass: "text-right",
          sortable: true,
          tdClass: "text-nowrap, text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "Gem", value: "Gem", disabled: false },
        { text: "Unique", value: "Unique", disabled: false },
        { text: "Div", value: "Div", disabled: false },
        { text: "Prophecy", value: "Prophecy", disabled: false },
        { text: "Map", value: "Map", disabled: false },
      ],
    };
  },
  mounted() {
    var subdomain = window.location.host.split(".")[1]
      ? window.location.host.split(".")[0]
      : false;
    if (subdomain === "private") {
      this.privateLeague = true;
    } else {
      this.privateLeague = false;
    }
  },
};
</script>

<style>
p,
h4 {
  color: white;
}
</style>
